import { motion } from "framer-motion";
import { Truck, HardHat, ShieldCheck, Star } from "lucide-react";
import { Reveal } from "./Reveal";

const CHAPTERS = [
  { num: "01", icon: Truck, title: "Reliable Moving Trucks", text: "Modern, well-maintained vehicles built for safe transportation of everything you own." },
  { num: "02", icon: HardHat, title: "Experienced Movers", text: "A professional, uniformed team that handles your belongings with genuine care." },
  { num: "03", icon: ShieldCheck, title: "Safe & Careful Service", text: "Your items are wrapped, strapped and protected from first box to final placement." },
  { num: "04", icon: Star, title: "Customer Satisfaction", text: "Quality service you can trust — backed by hundreds of five-star Melbourne moves." },
];

export const WhyChooseUs = () => (
  <section id="why-us" className="relative" data-testid="why-us-section">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:py-24 lg:px-10 lg:py-36">
      <Reveal>
        <div className="grid items-end gap-10 lg:grid-cols-2">
          <div>
            <p className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-blaze">Why Choose MoversNearby</p>
            <h2 className="max-w-3xl font-display text-4xl font-semibold uppercase leading-[0.95] tracking-tighter sm:text-5xl lg:text-6xl">
              Moving made easy<br />&amp; stress free
            </h2>
          </div>
          <div className="overflow-hidden rounded-2xl border border-slate-200 shadow-lg" data-testid="why-us-image">
            <img src="/images/movers-sofa.png" alt="MoversNearby movers carrying a sofa into a Melbourne home" className="h-56 w-full object-cover sm:h-64 lg:h-72" loading="lazy" />
          </div>
        </div>
      </Reveal>

      <div className="mt-16 lg:mt-24">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.num}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className="group grid items-center gap-4 border-t border-line py-10 transition-colors duration-500 last:border-b hover:bg-slate-100/70 sm:grid-cols-12 lg:py-14"
            data-testid={`why-chapter-${c.num}`}
          >
            <span className="font-display text-6xl font-semibold tracking-tighter text-stroke transition-all duration-500 group-hover:text-blaze group-hover:[-webkit-text-stroke:0px] sm:col-span-3 lg:text-8xl">
              {c.num}
            </span>
            <div className="flex items-center gap-4 sm:col-span-4">
              <c.icon className="h-7 w-7 shrink-0 text-blaze" strokeWidth={1.8} />
              <h3 className="font-display text-2xl font-semibold uppercase tracking-tight lg:text-3xl">{c.title}</h3>
            </div>
            <p className="text-sm leading-relaxed text-slate-600 sm:col-span-5 md:text-base">{c.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
